import { BeesafeNnwCoverage } from './beesafe-coverage-comparison-dialog.component';

export class BeesafeNnwCoveragesComparisonConfig {

    private readonly translationsContainerKey = 'BEESAFE_NNW_COVERAGES_COMPARISON';

    constructor() {}

    createConfig(): BeesafeNnwCoverageConfig[] {
        return [
            {
                coverageName: NnwCoverageName.PACKAGE_NAME,
                none: `${this.translationsContainerKey}.PACKAGE_NAME.none`,
                mini: `${this.translationsContainerKey}.PACKAGE_NAME.mini`,
                comfort: `${this.translationsContainerKey}.PACKAGE_NAME.comfort`
            },
            {
                coverageName: NnwCoverageName.NNW_DRIVER_DEATH,
                none: false,
                mini: `${this.translationsContainerKey}.NNW_DRIVER_DEATH.20tys`,
                comfort: `${this.translationsContainerKey}.NNW_DRIVER_DEATH.250tys`
            },
            {
                coverageName: NnwCoverageName.NNW_DRIVER,
                none: false,
                mini: `${this.translationsContainerKey}.NNW_DRIVER.20tys`,
                comfort: `${this.translationsContainerKey}.NNW_DRIVER.50tys`
            },
            {
                coverageName: NnwCoverageName.NNW_PASSENGER,
                none: false,
                mini: `${this.translationsContainerKey}.NNW_PASSENGER.10tys`,
                comfort: `${this.translationsContainerKey}.NNW_PASSENGER.10tys`
            }
        ]
    }
}

export interface BeesafeNnwCoverageConfig {
    coverageName: NnwCoverageName;
    none?: string | boolean;
    mini: string | boolean;
    comfort: string | boolean;
}

export interface AssistanceCoverageVariantPricing {
    name: BeesafeNnwCoverage;
    price: number;
}

export enum NnwCoverageName {
    PACKAGE_NAME = 'PACKAGE_NAME',
    NNW_DRIVER_DEATH = 'NNW_DRIVER_DEATH',
    NNW_DRIVER = 'NNW_DRIVER',
    NNW_PASSENGER = 'NNW_PASSENGER'
}
